<template>
  <div style="height: 100%;">
    <!-- 添加受益人 -->
    <div v-if="editable" class="add-beneficiary">
      <el-button type="primary" class="mb-[8px]" @click="addBeneficiary()">
        <svg-icon icon="lucide:circle-plus" />添加受益人
      </el-button>
      <div>
        <el-tag class="tips">
          公司的受益所有人应当按照以下标准依次判定：直接或者间接拥有超过25%公司股权或者表决权的自然人；通过人事、财务等其他方式对公司进行控制的自然人；公司的高级管理人员
        </el-tag>
      </div>
    </div>

    <!-- 受益人列表 -->
    <div class="beneficiary-list">
      <el-collapse v-model="activeName" accordion>
        <template v-for="(v, idx) in ruleForm.list" :key="idx">
          <el-collapse-item :name="String(idx)" class="relative">
            <template #title>
              <div v-if="showUboType" class="coll-title w-[150px] max-3xl:w-[150px] pl-4">
                受益人类型：<label>{{ uboOptions[v.idType].name || '——' }}</label>
              </div>
              <div v-if="showDocType" class="coll-title w-[150px] max-3xl:w-[150px] pl-4">
                证件类型：<label>身份证</label>
              </div>
              <div class="coll-title w-[260px] max-3xl:w-[240px]">
                {{ v.idType === 0 ? '受益人姓名' : '企业名称' }}：<label class="w-[160px] max-2xl:w-[100px] text-left">{{ v.uboName || '——' }}</label>
              </div>
              <div class="coll-title w-[350px] max-3xl:w-[280px]">
                {{ v.idType === 0 ? '受益人身份证号' : '社会统一信用代码' }}：<label class="w-[230px] max-3xl:w-[150px] text-left">{{ v.idNo || '——' }}</label>
              </div>
              <div class="coll-title">
                {{ v.idType === 0 ? '受益人地址' : '营业地址' }}：
                <label class="w-[600px] max-3xl:w-[160px] text-left">{{ v.uboAddress || '——' }}</label>
              </div>

              <el-button
                v-if="ruleForm.list.length > 1 && editable"
                link
                class="absolute right-[56px]"
                @click.prevent.stop="deleteInfo(idx)"
              >
                删除
              </el-button>
            </template>

            <el-form
              :ref="($event) => handle($event, idx)"
              require-asterisk-position="right"
              :disabled="!editable"
              label-position="top"
              :rules="editable ? rules : {}"
              :model="v"
            >
              <div class="beneficiary-item">
                <div class="left">
                  <el-form-item v-if="showUboType" label="受益人类型">
                    <el-select
                      v-if="enableIdType"
                      v-model="v.idType"
                      style="width: 313px;"
                      :placeholder="editable ? '请选择受益人类型' : '--'"
                      @change="changeIdType(idx)"
                    >
                      <el-option
                        v-for="item in uboOptions"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value"
                      />
                    </el-select>
                    <el-input v-else value="个人" disabled />
                  </el-form-item>
                  <el-form-item v-if="showDocType" label="证件类型">
                    <el-input value="身份证" disabled />
                  </el-form-item>
                  <el-form-item
                    v-if="v.idType === 0"
                    label="受益人身份证人像面"
                    prop="idNoFrontUrl"
                  >
                    <card-image-upload
                      :readonly="!editable"
                      :action="UploadImageUrls.idNoFront"
                      :image="v.idNoFrontUrl"
                      :placeholder-image="ssnFrontImg"
                      @on-success="(res: any) => {
                        const { idNoFrontInfo, picResult } = res || {};

                        v.idNoFrontUrl = picResult?.picUrl;
                        v.idNoFrontType = picResult?.picType;

                        v.uboName = idNoFrontInfo?.name;
                        v.idNo = idNoFrontInfo?.identNo;
                        v.uboAddress = idNoFrontInfo?.address;

                        formRefs[idx].validateField('idNo');
                        formRefs[idx].validateField('uboName');
                        formRefs[idx].validateField('uboAddress');
                        formRefs[idx].validateField('idNoFrontUrl');
                      }"
                    />
                  </el-form-item>
                  <el-form-item
                    v-if="v.idType === 1"
                    label="营业执照照片"
                    prop="businessLicensePic"
                  >
                    <card-image-upload
                      :readonly="!editable"
                      :action="UploadImageUrls.license"
                      :image="v.businessLicensePic"
                      @on-success="(res: any) => {
                        const { businessLicenseInfo, picResult } = res || {};

                        v.businessLicensePic = picResult?.picUrl;

                        v.uboName = businessLicenseInfo?.companyName;
                        v.idNo = businessLicenseInfo?.creditNo;
                        v.uboAddress = businessLicenseInfo?.address;
                        if (businessLicenseInfo?.startTime && businessLicenseInfo?.operatingPeriod) {
                          v.idNoExpiryStartDate = businessLicenseInfo.startTime.replace(/-/g, '');
                          v.idNoExpiryEndDate = businessLicenseInfo.operatingPeriod.replace(/-/g, '');
                          v.idNoExpiryDate = [
                            changeFormatToDate(v.idNoExpiryStartDate),
                            changeFormatToDate(v.idNoExpiryEndDate),
                          ];
                          v.isLongTerm = longTimeValues.includes(businessLicenseInfo?.operatingPeriod);
                        }

                        formRefs[idx].validateField('idNo');
                        formRefs[idx].validateField('uboName');
                        formRefs[idx].validateField('uboAddress');
                        formRefs[idx].validateField('businessLicensePic');
                      }"
                    />
                  </el-form-item>
                  <el-form-item
                    :label="v.idType === 0 ? '受益人名称': '企业名称'"
                    prop="uboName"
                  >
                    <el-input v-model="v.uboName" clearable :placeholder="editable ? v.idType === 0 ? '请输入受益人名称' : '请输入企业名称' : '--'" @keyup.enter="onKeyupEnter(idx)" />
                  </el-form-item>
                  <el-form-item
                    label="受益人名称（拼音）"
                    prop="uboNameEn"
                  >
                    <el-input v-model="v.uboNameEn" clearable :placeholder="editable ? '请输入受益人名称（拼音）' : '--'" @keyup.enter="onKeyupEnter(idx)" />
                  </el-form-item>
                  <el-form-item
                    :label="v.idType === 0 ? '受益人地址': '营业地址'"
                    prop="uboAddress"
                  >
                    <el-input
                      v-model="v.uboAddress"
                      :placeholder="editable ? v.idType === 0 ? '请输入受益人地址' : '请输入企业营业地址' : '--'"
                      clearable
                      @keyup.enter="onKeyupEnter(idx)"
                    />
                  </el-form-item>
                  <el-form-item
                    v-if="enableUboPhone"
                    prop="phone"
                    label="受益人手机号"
                    :rules="[
                      {
                        required: true,
                        validator: (rule: any, value: string, callback: any) => {
                          if (checkPhone(v.phone, '受益人')) {
                            callback(checkPhone(v.phone, '受益人'));
                          }
                          callback();
                        },
                      },
                    ]"
                  >
                    <el-input
                      v-model="v.phone"
                      clearable
                      autocomplete="nony"
                      placeholder="请输入"
                      @keyup.enter="onKeyupEnter(idx)"
                    />
                  </el-form-item>
                </div>
                <div class="right">
                  <el-form-item label="">
                    <span class="h-[72px]" />
                  </el-form-item>
                  <el-form-item
                    v-if="v.idType === 0"
                    label="受益人身份证国徽面"
                    prop="idNoBackUrl"
                  >
                    <card-image-upload
                      :readonly="!editable"
                      :action="UploadImageUrls.idNoBack"
                      :image="v.idNoBackUrl"
                      :placeholder-image="ssnBackImg"
                      @on-success="(res: any) => {
                        const { idNoBackInfo, picResult } = res || {};

                        v.idNoBackUrl = picResult?.picUrl;
                        v.idNoBackType = picResult?.picType;

                        if (idNoBackInfo?.startDate && idNoBackInfo?.endDate) {
                          v.idNoExpiryStartDate = idNoBackInfo.startDate.replace(/-/g, '');
                          v.idNoExpiryEndDate = idNoBackInfo.endDate.replace(/-/g, '');
                          v.idNoExpiryDate = [
                            changeFormatToDate(v.idNoExpiryStartDate),
                            changeFormatToDate(v.idNoExpiryEndDate),
                          ];
                          v.isLongTerm = longTimeValues.includes(idNoBackInfo?.endDate);
                        }

                        formRefs[idx].validateField('idNoBackUrl');
                        formRefs[idx].validateField('idNoExpiryDate');
                      }"
                    />
                  </el-form-item>
                  <el-form-item
                    v-if="v.idType === 1"
                    label=""
                  >
                    <span class="h-[232px]" />
                  </el-form-item>
                  <el-form-item
                    :label="v.idType === 0 ? '受益人身份证件号': '社会统一信用代码'"
                    prop="idNo"
                    :rules="editable ?
                      v.idType === 0 ?
                        [
                          {
                            required: true,
                            validator: (rule: any, value: string, callback: any) => {
                              if (checkSSNId(v.idNo)) {
                                callback(checkSSNId(v.idNo, '受益人'));
                              }
                              callback();
                            },
                          },
                        ]:
                        [{required: true, message: '请输入社会统一信用代码'}] :
                      undefined"
                  >
                    <el-input v-model="v.idNo" clearable :placeholder="editable ? '请输入受益人身份证件号' : '--'" @keyup.enter="onKeyupEnter(idx)" />
                  </el-form-item>
                  <el-form-item
                    label="证件有效期"
                    prop="idNoExpiryDate"
                  >
                    <el-date-picker
                      v-model="v.idNoExpiryDate"
                      type="daterange"
                      clearable
                      :start-placeholder="editable ? '创建时间(起)' : '--'"
                      format="YYYY-MM-DD"
                      value-format="YYYY-MM-DD"
                      :end-placeholder="editable ? '创建时间(止)' : '--'"
                      @change="v.isLongTerm = false"
                    />
                    <el-checkbox
                      v-model="v.isLongTerm"
                      class="ml-[24px]"
                      label="长期"
                      :disabled="!editable || v.isLongTerm === true"
                      @change="changeLongTerm(idx)"
                    />
                  </el-form-item>
                  <el-form-item
                    v-if="enableIdType"
                    label="受益人所有人类型"
                    prop="uboType"
                  >
                    <el-select
                      v-model="v.uboType"
                      :placeholder="editable ? '请选择受益人所有人类型' : '--'"
                      clearable
                      filterable
                    >
                      <el-option
                        v-for="item in +v.idType === 0 ? personOptions : companyOptions"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>
                </div>
              </div>
            </el-form>
          </el-collapse-item>
        </template>
      </el-collapse>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ElMessage } from 'element-plus';
import { CardImageUpload } from '@vue3/components';
import { type IBeneficiary, type IBeneficiaryMode } from './types';
import { onConfirm, SvgIcon } from '@vue3/components';
import { FormInstance } from 'element-plus';
import { computed, PropType, reactive, watch } from 'vue';
import { ref } from 'vue';
import { changeFormatToDate, checkPhone, checkSSNId, isNull, scrollToErrorField, longTimeValues } from '@core/tools';
import { UploadImageUrls } from '../../../api/common';
import ssnFrontImg from '@app/assets/images/ssn-front.png';
import ssnBackImg from '@app/assets/images/ssn-back.png';

defineOptions({ name: 'BeneficiaryInfo' }); // 受益人信息组件

const props = defineProps({
  type: {
    type: String as PropType<IBeneficiaryMode>,
    default: 'edit',
  },
  showUboType: {
    type: Boolean,
    default: true,
  },
  /** 显示证件类型 */
  showDocType: {
    type: Boolean,
    default: false,
  },
  enableUboPhone: {
    type: Boolean,
    default: false,
  },
  timeWithConnector: {
    type: Boolean,
    default: false,
  },
  /**
   * 是否支持受益人类型选择
   * @default false
   */
  enableIdType: {
    type: Boolean,
    default: false,
  },
  enableEnterKey: {
    type: Boolean,
    default: true,
  },
  /** 自动滚动到错误位置 */
  autoScrollToError: {
    type: Boolean,
    default: true,
  },
  data: {
    type: Array as PropType<IBeneficiary[]>,
    default: () => [],
  },
  /**
   * 长期时间格式
   * @default 2999-12-31
   */
  longTimeFormat: {
    type: String,
    default: longTimeValues[2],
  },
});

const emit = defineEmits<{'key-enter': []}>();

const editable = computed(() => props.type === 'edit');

const uboOptions = ref([
  {
    name: '个人',
    value: 0,
  },
  {
    name: '企业',
    value: 1,
  },
]);

const personOptions = ref([
  {
    name: '受益所有人',
    value: 'ubo',
  },
  {
    name: '实控人',
    value: 'uac',
  },
  {
    name: '股东',
    value: 'shareholder',
  },
]);

const companyOptions = ref([
  {
    name: '实控人',
    value: 'uac',
  },
  {
    name: '股东',
    value: 'shareholder',
  },
]);

const formRefs = ref<FormInstance[]>([]);

const rules = reactive({
  idNoFrontUrl: [
    {
      required: true,
      message: '请选择受益人身份证人像面',
      trigger: 'change',
    },
  ],
  businessLicensePic: [
    {
      required: true,
      message: '请选择营业执照照片',
      trigger: 'change',
    },
  ],
  idNoBackUrl: [
    {
      required: true,
      message: '请选择受益人身份证国徽面',
      trigger: 'change',
    },
  ],
  uboName: [
    {
      required: true,
      message: '请输入受益人名称',
    },
  ],
  uboType: [
    {
      required: true,
      message: '请选择受益人所有人类型',
    },
  ],
  uboNameEn: [
    {
      required: true,
      message: '请输入受益人名称（拼音）',
    },
  ],
  idNoExpiryDate: [
    {
      required: true,
      message: '请选择证件有效期',
    },
  ],
  uboAddress: [
    {
      required: true,
      message: '请输入受益人地址',
    },
  ],
});

const activeName = ref('0');
const ruleForm = ref<{ list: IBeneficiary[] }>({ list: [] });

function addBeneficiary(toast = true) {
  ruleForm.value.list.push({ idType: 0 } as IBeneficiary);
  activeName.value = String(ruleForm.value.list.length - 1);
  toast && ElMessage.success('添加成功');
}

function changeIdType(index: number) {
  const item = ruleForm.value.list[index];

  formRefs.value[index].resetFields();

  for (const key in item) {
    if (key !== 'idType') {
      item[key] = undefined;
    }
  }
}

function handle(e: any, index: any) {
  // 保存下每个ref
  formRefs.value[index] = e;
}

function deleteInfo(index: number) {
  onConfirm({
    message: '是否确认当前操作',
    onOk: async () => {
      try {
        formRefs.value.splice(index, 1);
        ruleForm.value.list.splice(index, 1);
      } catch (err) {
        console.log(err);
      }
    },
  });
}

function changeLongTerm(index: number) {
  if (ruleForm.value.list[index].isLongTerm) {
    const time = ruleForm.value.list[index].idNoExpiryDate;

    ruleForm.value.list[index].idNoExpiryDate = [!time || !time?.[0] ? '1950-01-01' : time[0], props.longTimeFormat];
    formRefs.value[index].validateField('idNoExpiryDate');
  }
}

async function validate() {
  let isSubmit: boolean[] = [];

  for (const el of formRefs.value) {
    await el?.validate((valid: any) => {
      if (valid) {
        isSubmit.push(true);
      } else {
        isSubmit.push(false);
      }
    });
  }
  let has = isSubmit.every((i) => i == true);

  let idx = isSubmit.findIndex((i) => i == false);

  if (idx > -1) {
    activeName.value = String(idx);

    setTimeout(() => {
      if (props.autoScrollToError) scrollToErrorField(formRefs.value[idx].$el);
    }, 330);
  }

  return has;
}

async function currentValidate(index: number, callback?: () => void) {
  let valid = false;

  if (!formRefs.value[index]) return valid;

  await formRefs.value[index].validate((v) => {
    if (v) {
      valid = true;
      callback && callback();
    } else {
      if (props.autoScrollToError) scrollToErrorField(formRefs.value[index].$el);
    }
  });

  return valid;
}

async function onKeyupEnter(index: number) {
  if (!props.enableEnterKey) return;

  const valid = await currentValidate(index);

  if (valid) {
    let checks: boolean[] = [];

    for (const el of formRefs.value) {
      await el?.validate((valid: any) => {
        if (valid) {
          checks.push(true);
        } else {
          checks.push(false);
        }
      });
    }
  }

  emit('key-enter');
}

watch(
  [
    () => props.data,
    () => props.type,
  ],
  () => {

    const list = JSON.parse(JSON.stringify(props.data)) as IBeneficiary[];

    ruleForm.value.list = list;
    ruleForm.value.list.forEach((v) => {
      v.idType = isNull(v.idType) ? 0 : v.idType;
      if (v.idNoExpiryStartDate && v.idNoExpiryEndDate) {
        v.idNoExpiryDate = [
          changeFormatToDate(v.idNoExpiryStartDate),
          changeFormatToDate(v.idNoExpiryEndDate),
        ];
      }
      if (longTimeValues.includes(v.idNoExpiryEndDate)) {
        v.isLongTerm = true;
      }
    });
    if (ruleForm.value.list.length === 0) {
      addBeneficiary(false);
    }
    if (editable.value) {
      setTimeout(() => {
        formRefs.value.map((v) => v?.clearValidate?.());
      }, 0);
    }

  },
  { immediate: true },
);

defineExpose({
  /**
   * 受益人信息校验
   *
   * return {boolean} true 通过， false失败
  */
  validate,
  /** 受益人表单数据重置（base props.data） */
  reset: () => {
    formRefs.value.map((v) => v.resetFields());
    ruleForm.value.list = JSON.parse(JSON.stringify(props.data)) as IBeneficiary[];
  },
  /** 受益人信息 */
  getValues: () => {
    const l = JSON.parse(JSON.stringify(ruleForm.value.list)) as IBeneficiary[];

    for (const v of l) {
      v.idNoExpiryStartDate = v.idNoExpiryDate?.[0];
      v.idNoExpiryEndDate = v.idNoExpiryDate?.[1];

      delete v.isLongTerm;
      delete v.idNoExpiryDate;

      if (!props.timeWithConnector) {
        v.idNoExpiryStartDate = v.idNoExpiryStartDate?.replace(/-/g, '');
        v.idNoExpiryEndDate = v.idNoExpiryEndDate?.replace(/-/g, '');
      }

      if (!props.enableIdType) {
        v.uboType = 'ubo';
        continue;
      }

      if (v.idType === 0) {
        delete v.businessLicensePic;
      } else {
        delete v.idNoFrontUrl;
        delete v.idNoBackUrl;
        delete v.idNoBackType;
        delete v.idNoFrontType;
      }

      v.businessLicensePic = v.businessLicensePic || undefined;
      v.phone = props.enableUboPhone ? v.phone : undefined;
    }

    return l;
  },
});

</script>

<style lang="scss" scoped>
.add-beneficiary {
  @apply mb-[28px] pr-[0] pb-[0];

  .tips {
    @apply text-[12px] rounded-[2px] px-[12px] py-[6px];
  }
}

.beneficiary-list {
  @apply flex flex-col gap-y-[40px] pr-[0] pb-[0] pt-[0];

  .coll-title {
    @apply flex justify-start text-[#6B7891] cursor-pointer;

    label {
      display: inline-block;
      cursor: pointer;
      font-weight: 600;
      height: 36px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }

  :deep(.file-icon) {
    @apply w-[16px] h-[16px];
  }

  :deep(.el-collapse-item__wrap) {
    @apply pt-5 pl-6;
  }

  :deep(.el-collapse-item.is-active) {
    .el-collapse-item__header {
      @apply bg-[#F5F6FA];

      .coll-title {
        label {
          font-weight: normal;
        }
      }
    }
  }

  :deep(.hauto .el-form-item__content) {
    line-height: 0;
  }

  .beneficiary-item {
    @apply flex;

    .el-form-item {
      @apply mb-[20px];

      :deep(.el-form-item__label) {
        @apply text-[#6B7891];
      }

      :deep(.el-form-item__content) {
        .el-input,
        .el-select__wrapper {
          @apply h-[40px];
        }

        .el-date-editor {
          @apply w-[350px] h-[40px];
        }

        .el-checkbox__input.is-checked+.el-checkbox__label,
        .el-checkbox__label {
          @apply text-[#6B7891]
        }
      }
    }

    .left {
      @apply w-[432px] mr-[114px];
    }

    .right {
      @apply w-[432px];
    }
  }
}
</style>
